export default __webpack_public_path__ + "static/392-5d1405ead840a7760bae72c1696c7dda.gif";